<script setup lang="ts">
import { Input } from '@/components/ui/input';
import Label from '@/components/ui/label/Label.vue';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { states } from '@/helpers/states';

withDefaults(
    defineProps<{
        modelValue: string
        hasForeignDoc: boolean
        required?: boolean
        error?: string
    }>(),
    {
        required: true,
        error: '',
    },
)

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

function updateValue(value: string) {
    emit('update:modelValue', value)
}
</script>

<template>
    <div class="flex flex-col gap-1.5">
        <Label :required="required" for="state">{{ $t('State') }}</Label>

        <Select id="state" :model-value="modelValue" @update:model-value="(value) => updateValue(value as string)" v-if="!hasForeignDoc">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Selecione um estado')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem v-for="state in states" :key="state.region_code" :value="state.region_code">
                    {{ state.name }}
                </SelectItem>
            </SelectContent>
        </Select>

        <Input
            type="text"
            id="state"
            :model-value="modelValue"
            @update:model-value="(value) => updateValue(value as string)"
            :placeholder="$t('State')"
            v-else
        />

        <p v-if="error" class="text-destructive text-xs">
            {{ error }}
        </p>
    </div>
</template>
